import React, {ReactNode} from 'react';
import {makeStyles} from "@mui/styles";
import {Theme} from "@mui/material";
import AppHeader from "./AppHeader";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        background: theme.palette.background.default
    },
    main: {
        flex: "1 1",
        overflow: "hidden",
        display: "flex"
    },
    content: {
        flex: "1 1",
        overflowY: "auto",
    }
}));

interface Props {
    readonly children: ReactNode;

}

function AppWrapper({children}: Props) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
             <AppHeader />
            <div className={classes.main}>
                <div className={classes.content}>{children}</div>
            </div>
        </div>
    );
}

export default AppWrapper;